import React from 'react'
import { useSelector } from 'react-redux'
import { Text } from '@components/base'
import { BottomSheet, OutlinedIcon } from '@components'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { uhcDeepLinkSelector } from '@selectors/app.ts'
import { openUrl } from '@utils'
import { useUhcSubscriptionExpiredModal } from '@screens/Uhc/hooks/useUhcSubscriptionExpiredModal.ts'

export const UhcSubscriptionExpiredModal = () => {
  const styles = useStyleSheet(themedStyles)
  const uhcDeepLinks = useSelector(uhcDeepLinkSelector)
  const { setModalClosed } = useUhcSubscriptionExpiredModal()

  const onPress = () => {
    openUrl(uhcDeepLinks.storeUrl)
  }

  const onDismissHandler = () => {
    setModalClosed(true)
  }

  return (
    <BottomSheet
      style={styles.container}
      primaryButton={{ text: 'Visit the UHC Store', onPress }}
      onDismiss={onDismissHandler}
    >
      <OutlinedIcon iconName="warning" style={styles.icon} />
      <Text type="title-3" style={styles.text}>
        Your subscription has ended
      </Text>
      <Text type="regular" style={styles.text}>
        We’d love to help you keep going on your health journey.
      </Text>
      <Text type="regular" style={styles.text}>
        Visit the UHC Store to choose a one-time or monthly plan and keep using the Nutrisense app.
      </Text>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  container: {
    paddingHorizontal: 24,
  },
  text: {
    marginBottom: 24,
    textAlign: 'center',
  },
  icon: {
    alignSelf: 'center',
  },
})
